// Auto-generated optimized asset mappings
// Generated on: 2025-06-02T09:52:38.515Z

export interface OptimizedVideo {
  original: string;
  webm: string;
  fallback?: string;
}

export interface OptimizedImage {
  original: string;
  webp: string;
  avif: string;
  fallback: string;
}

// Optimized video URLs (WebM format with ~60% size reduction)
export const optimizedVideos: Record<string, OptimizedVideo> = {
  // Features section - Old version 
  // 'smallint-dark': {
  //   original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173115/mocktrail-smallint-darkui_nxi775.mov',
  //   webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173115/mocktrail-smallint-darkui_nxi775.webm'
  // },
  // 'smallint-light': {
  //   original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173120/mocktrail-smallint-lightui_cukfho.mov',
  //   webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173120/mocktrail-smallint-lightui_cukfho.webm'
  // },

  'smallint-dark': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1750404492/mocktrail-smallint-v2-darkui_jvhqry.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1750404492/mocktrail-smallint-v2-darkui_jvhqry.webm'
  },
  'smallint-light': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1750404491/mocktrail-smallint-v2-lightui_g2t6cb.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1750404491/mocktrail-smallint-v2-lightui_g2t6cb.webm'
  },

  // Experience section
  'schedule-dark': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173112/mocktrail-scheduleint-darkui_cdwzk1.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173112/mocktrail-scheduleint-darkui_cdwzk1.webm'
  },
  'schedule-light': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173112/mocktrail-scheduleint-lightui_rmjcyk.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173112/mocktrail-scheduleint-lightui_rmjcyk.webm'
  },
  'camera-dark': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173120/mocktrail-camera-darkui_gnyxjr.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173120/mocktrail-camera-darkui_gnyxjr.webm'
  },
  'camera-light': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173105/mocktrail-camera-lightui_esv0jm.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173105/mocktrail-camera-lightui_esv0jm.webm'
  },
  
  // How it works section
  'boarding-dark': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173108/mocktrail-boarding-darkui_jyokky.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173108/mocktrail-boarding-darkui_jyokky.webm'
  },
  'boarding-light': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173972/mocktrail-boarding-lightui_pjcajj.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173972/mocktrail-boarding-lightui_pjcajj.webm'
  },
  'choose-dark': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173103/mocktrail-chooseint-darkui_gqpzqj.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173103/mocktrail-chooseint-darkui_gqpzqj.webm'
  },
  'choose-light': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173106/mocktrail-chooseint-lightui_j7nqmc.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173106/mocktrail-chooseint-lightui_j7nqmc.webm'
  },
  'startint-dark': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173124/mocktrail-startint-darkui_ofswfu.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173124/mocktrail-startint-darkui_ofswfu.webm'
  },
  'startint-light': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748174130/mocktrail-startint-lightui_iawefs.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748174130/mocktrail-startint-lightui_iawefs.webm'
  },
  'feedbpk-dark': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173113/mocktrail-getfeedback-darkui_tezouq.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173113/mocktrail-getfeedback-darkui_tezouq.webm'
  },
  'feedbpk-light': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1748173115/mocktrail-getfeedback-lightui_rcyiik.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1748173115/mocktrail-getfeedback-lightui_rcyiik.webm'
  },
  // Hero video
  'hero-demo-dark': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1750404498/mocktrail-herovid-darkui_rmbjkd.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1750404498/mocktrail-herovid-darkui_rmbjkd.webm'
  },
  'hero-demo-light': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1750404498/mocktrail-herovid-lightui_vjwciz.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1750404498/mocktrail-herovid-lightui_vjwciz.webm'
  },
  'hero-demo-mobile-dark': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1750408429/mocktrail-herovid-mobile-darkui_pd4cgt.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1750408429/mocktrail-herovid-mobile-darkui_pd4cgt.webm'
  },
  'hero-demo-mobile-light': {
    original: 'https://res.cloudinary.com/dxgp53qed/video/upload/v1750408429/mocktrail-herovid-mobile-lightui_qojxzm.mov',
    webm: 'https://res.cloudinary.com/dxgp53qed/video/upload/f_webm,q_auto:eco,w_1920/v1750408429/mocktrail-herovid-mobile-lightui_qojxzm.webm'
  }
};

// Device-specific video quality
export const getOptimizedVideoUrl = (videoKey: string, options?: {
  isMobile?: boolean;
  isSlowConnection?: boolean;
  preferQuality?: 'high' | 'medium' | 'low';
}): string => {
  const video = optimizedVideos[videoKey];
  if (!video) return '';
  
  const { isMobile = false, isSlowConnection = false, preferQuality = 'medium' } = options || {};
  
  // For mobile or slow connections, use lower quality
  if (isMobile || isSlowConnection || preferQuality === 'low') {
    return video.webm.replace('w_1920', 'w_1280,q_auto:low');
  }
  
  // For high quality preference or fast connections
  if (preferQuality === 'high') {
    return video.webm.replace('q_auto:eco', 'q_auto:good');
  }
  
  // Default: eco quality for balanced performance
  return video.webm;
};

// Helper to get video URLs by theme
export const getThemeVideoUrls = (baseKey: string, isDark: boolean, options?: Parameters<typeof getOptimizedVideoUrl>[1]) => {
  const darkKey = `${baseKey}-dark`;
  const lightKey = `${baseKey}-light`;
  
  return {
    dark: getOptimizedVideoUrl(darkKey, options),
    light: getOptimizedVideoUrl(lightKey, options),
    current: getOptimizedVideoUrl(isDark ? darkKey : lightKey, options)
  };
};

// Image optimization helpers
export const getOptimizedImageUrl = (imageName: string, format: 'webp' | 'avif' | 'original' = 'webp'): string => {
  const baseName = imageName.replace(/\.[^/.]+$/, '');
  
  switch (format) {
    case 'avif':
      return `/optimized/${baseName}.avif`;
    case 'webp':
      return `/optimized/${baseName}.webp`;
    default:
      return `/${imageName}`;
  }
};

// Progressive image loading with fallbacks
export const getImageSources = (imageName: string) => ({
  avif: getOptimizedImageUrl(imageName, 'avif'),
  webp: getOptimizedImageUrl(imageName, 'webp'),
  fallback: getOptimizedImageUrl(imageName, 'original')
});
